import React from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/outline'


export const InputUi = ({ label, name, disabled = false, type = 'text', error, LeftIcon, placeholder, register, validations, defaultValue, bg = 'bg-transparent' }) => (
  <div className="py-2">
    <label htmlFor={name} className="block text-xs font-medium text-gray-600">{label}</label>
    <div className="mt-1 relative rounded-md shadow-sm">
      {
        LeftIcon &&
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <LeftIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
      }
      <input
        name={name}
        id={name}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        aria-invalid={error ? "true" : "false"}
        {...register(name, validations)}
        className={`block w-full ${bg} border-indigo-300 ${LeftIcon && 'px-10'} focus:outline-none focus:ring-indigo-300 focus:border-indigo-300 sm:text-sm rounded-md`}
        defaultValue={defaultValue}
      />
      {
        error && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
        </div>
      }
    </div>
    {error && <p className="mt-2 text-xs text-red-600" id="email-error">{error}</p>}
  </div>
);


export const SelectUi = ({ label, register, validations, name, error, children }) => (
  <div  className="py-2">
    <label htmlFor={name} className="block text-xs font-medium text-gray-600">{label}</label>
    <select
      id={name}
      name={name}
      {...register(name, validations)}
      aria-invalid={error ? "true" : "false"}
      className="block w-full  border-gray-300 relative focus:outline-none bg-transparent focus:z-10 focus:ring-indigo-300 focus:border-indigo-300 sm:text-sm  rounded-md"
    >
      {children}
    </select>
    {error && <p className="mt-2 text-xs text-red-600" id="email-error">{error}</p>}
  </div>
)



export const TextAreaUi = ({label, name,rows = 4, defaultValue, error, register, validations}) => {
  return (
    <div  className="py-2">
    <label htmlFor={name} className="block text-xs font-medium text-gray-600">{label}</label>
        <textarea
          rows={rows}
          name={name}
          defaultValue={defaultValue}
          {...register(name, validations)}
          aria-invalid={error ? "true" : "false"}
          className={`block w-full border-indigo-300 focus:outline-none focus:ring-indigo-300 focus:border-indigo-300 sm:text-sm rounded-md`}
        />
        {error && <p className="mt-2 text-xs text-red-600" id="email-error">{error}</p>}
    </div>
  )
}

export const InputFile = ({name, onChange, classes}) => {
  return (
    <input 
      type="file" id={name} 
      onChange={onChange} 
      name={name} 
      accept="image/png, image/jpg, image/jpeg" 
      className={`opacity-0 ${classes}`}
    />
  )
}

